<template>
  <v-parallax :src="`data:image/png;base64,${bannerTopo}`" height="500">
    <v-layout column align-center justify-center class="white--text">
      <h1 class="white--text mb-2 display-3 text-center">{{ nomeSistema }}</h1>
      <div class="subheading mb-4 text-center">
        <p>
          {{ textoBanner }}
        </p>
      </div>
      <div class="subheading mb-4 text-center hidden-sm-and-down">
        <v-layout wrap align-center justify-center class="white--text">
          <v-flex class="ma-1" xs12 md3 v-if="habilitadoCardEntrar">
            <v-icon class="white--text" x-large>airplay</v-icon>
            <div class="title">{{ tituloCardEntrar }}</div>
            <v-divider dark></v-divider>
            <div class="font-weight-thin">
              {{ textoCardEntrar }}
            </div>
            <v-btn small class="mt-2" outlined color="white" router to="login">
              <v-icon small left>exit_to_app</v-icon>
              <span>{{ botaoCardEntrar }}</span>
            </v-btn>
          </v-flex>
          <v-flex class="ma-1" xs12 md3 v-if="habilitadoCardPrimeiroAcesso">
            <v-icon class="white--text" x-large>lock</v-icon>
            <div class="title">{{ tituloCardPrimeiroAcesso }}</div>
            <v-divider dark></v-divider>
            <div class="font-weight-thin">
              {{ textoCardPrimeiroAcesso }}
            </div>
            <v-layout justify-center>
              <v-flex xs12 md6>
                <v-btn small class="mt-2" outlined dark @click="solicitaSenha">
                  <v-icon small left>password</v-icon>
                  <span>{{ botaoCardPrimeiroAcesso }}</span>
                </v-btn>
              </v-flex>
              <!-- <v-flex xs12 md6 class="ml-2">
                <v-btn
                  small
                  dark
                  class="mt-2"
                  color="primary"
                  router
                  to="recuperarEmail"
                >
                  <span>Novo e-mail</span>
                </v-btn>
              </v-flex> -->
            </v-layout>
          </v-flex>
          <v-flex class="ma-1" xs12 md3 v-if="habilitadoCardCadastro">
            <v-icon class="white--text" x-large>contact_mail</v-icon>
            <div class="title">{{ tituloCardCadastro }}</div>
            <v-divider dark></v-divider>
            <div class="font-weight-thin">
              {{ textoCardCadastro }}
            </div>
<!--            <v-btn small class="mt-2" outlined dark routev-on:click="abrePopUp()">-->
<!--              <v-icon small left>account_box</v-icon>-->
<!--              <span>{{ botaoCardCadastro }}</span>-->
<!--            </v-btn>-->


            <v-menu offset-y class="menu-cadastro">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined small dark
                       v-bind="attrs"
                       v-on="on">
                  <v-icon small left>mdi-arrow-down</v-icon>
                  {{ botaoCardCadastro }}
                </v-btn>
              </template>
              <v-list class="pa-0">
                <v-list-item
                    v-for="(item, index) in opcoesCadastro"
                    :key="index">
                  <v-list-item-title @click="abrePopUpUrl(item.url)">{{ item.opcao }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

          </v-flex>
        </v-layout>
      </div>
    </v-layout>
  </v-parallax>
</template>

<script>
import {base_url} from "../global";
import CpfCnpjMixin from "@/mixins/CpfCnpjMixin";

export default {
  mixins: [CpfCnpjMixin],
  props: {
    nomeSistema: {
      type: String,
      default: "Nota Fiscal de Serviços Eletrônica",
    },
    textoBanner: {
      type: String,
      default: "",
    },
    linkCadastro: {
      type: String,
    },
    bannerTopo: {
      type: String,
    },

    permiteRedefinicaoEmail: {
      type: Boolean,
    },

    habilitadoCardEntrar: {
      type: Boolean,
    },
    tituloCardEntrar: {
      type: String,
    },
    textoCardEntrar: {
      type: String,
    },
    botaoCardEntrar: {
      type: String,
    },

    habilitadoCardPrimeiroAcesso: {
      type: Boolean,
    },
    tituloCardPrimeiroAcesso: {
      type: String,
    },
    textoCardPrimeiroAcesso: {
      type: String,
    },
    botaoCardPrimeiroAcesso: {
      type: String,
    },

    habilitadoCardCadastro: {
      type: Boolean,
    },
    tituloCardCadastro: {
      type: String,
    },
    textoCardCadastro: {
      type: String,
    },
    botaoCardCadastro: {
      type: String,
    },

    habilitadoAutenticacaoPessoaFisica: {
      type: Boolean,
    },
    habilitadoAutenticacaoPessoaJuridica: {
      type: Boolean,
    },

    urlCadastroAvulsaPessoaFisica: {
      type: String,
    },
    urlCadastroAvulsaPessoaJuridica: {
      type: String,
    }
  },
  data() {
    return {
      opcoesCadastro: [],
      linkCredenciamento: `${base_url}/notafiscal/paginas/contribuintefora/contribuinteForaList.jsf?faces-redirect=true&incluir=S`,
    };
  },
  mounted() {
    this.opcoesCadastro.push({"opcao": "Pessoa Física", "url": this.urlCadastroAvulsaPessoaFisica});
    this.opcoesCadastro.push({"opcao": "Pessoa Jurídica", "url": this.urlCadastroAvulsaPessoaJuridica});
  },
  methods: {
    solicitaSenha() {
      return this.$router.push({
        name: 'SolicitarSenha',
        params: {
          cpf: this.habilitadoAutenticacaoPessoaFisica,
          cnpj: this.habilitadoAutenticacaoPessoaJuridica,
          permiteRedefinicaoEmail: this.permiteRedefinicaoEmail
        }
      });
    },
    abrePopUp() {
      let url = this.habilitadoAutenticacaoPessoaFisica ? this.urlCadastroAvulsaPessoaFisica : this.urlCadastroAvulsaPessoaJuridica;
      this.abrePopUpUrl(url)
    },
    abrePopUpUrl(url) {
      window.open(url, 'Pagina', 'resizable=0,WIDTH=1024, HEIGHT=640')
    }
  },
};
</script>
